import FocusTrap from 'focus-trap-react';
import React from 'react';
import cx from 'classnames';
import { COLORS, FullThemeStyle } from '@treelab/panda';

import './index.css';

export interface IModalProps {
  /** Modal children */
  children: React.ReactElement;
  /** Optional passed classname */
  className?: string;
  /** Mandatory onClose */
  onClose: () => void;
  /** Option index number for stacking modals */
  modalIndex?: number;
  /** Optional theme */
  theme?: FullThemeStyle;
  /** Optional suppression for focus trap */
  suppressFocusTrap?: boolean;
  suppressMask?: boolean;
  /** Injected styles for width height etc. */
  style?: object;
}

export class Modal extends React.PureComponent<IModalProps> {
  render() {
    const {
      className,
      children,
      modalIndex = 0,
      onClose,
      theme = FullThemeStyle.white,
      suppressFocusTrap,
      suppressMask,
      style,
    } = this.props;
    const zIndex = 1000 + modalIndex;
    const combinedClass = cx({
      'panda-modal': true,
      [className || '']: !!className,
    });

    return (
      <>
        <div
          className={`panda-modal-mask${suppressMask ? '' : ' panda-modal-mask--bg'}`}
          onMouseDown={onClose}
          style={{ zIndex }}
        />
        <FocusTrap active={!suppressFocusTrap}>
          <div
            style={{
              zIndex: zIndex + 1,
              backgroundColor: COLORS[theme],

              ...style,
            }}
            className={combinedClass}
            onKeyDown={this.handleKeyDown}
          >
            {children}
          </div>
        </FocusTrap>
      </>
    );
  }

  handleKeyDown = (e: React.KeyboardEvent) => {
    switch (e.keyCode) {
      case 27:
        this.props.onClose();
        break;
      default:
        break;
    }
  };
}
